import { Table, TableBody, TableContainer, TableHead, TableRow, useTheme } from '@mui/material'
import React from 'react'
import { Employee } from '../../../types/Employee/Employee'
import { StyledTableCell } from '../../core/StyledTableCell'
import { useNavigate } from 'react-router-dom'
import { Chip } from '@mui/material'
import { TimeSheetDialog } from './TimesheetDialog'
import VerifiedIcon from '@mui/icons-material/Verified'
import CancelIcon from '@mui/icons-material/Cancel'

type QCSelectionProps = {
	indirectWorkers: Employee[]
	postConfirmLoadData: () => void
	department: string
	shiftDate: Date
}

export function ShiftEndSelectIndirect({
	indirectWorkers,
	postConfirmLoadData,
	department,
	shiftDate,
}: QCSelectionProps) {
	const navigate = useNavigate()
	const theme = useTheme()
	const isSupervisor = indirectWorkers[0]?.role.title.includes('Manager')

	return (
		<TableContainer sx={{ height: '100%', width: '100%', overflowX: 'scroll' }}>
			<Table>
				<TableHead>
					<TableRow>
						<StyledTableCell align='left'>Name</StyledTableCell>
						<StyledTableCell align='center'>Time Sheet</StyledTableCell>
						<StyledTableCell align='center'>Employee ID</StyledTableCell>
						<StyledTableCell align='center'>Primary Craft</StyledTableCell>
						<StyledTableCell align='center'>Worker Class</StyledTableCell>
						<StyledTableCell align='center'>Status</StyledTableCell>
						{!isSupervisor && <StyledTableCell align='center'>Report Uploaded</StyledTableCell>}
					</TableRow>
				</TableHead>
				<TableBody>
					{indirectWorkers.map((indirect) => {
						const submitted = indirect.submittedTimesheetCount ?? 0
						const total = indirect.directReportCount ?? 0
						const allSubmitted = total > 0 && submitted === total
						return (
						<TableRow
							key={indirect.id}
							onClick={() => {
								if (isSupervisor) {
									navigate(`/${department.toLowerCase()}Reports/${indirect.id}`)
								}
							}}
							sx={{
								cursor: isSupervisor ? 'pointer' : 'default',
								'&:hover': isSupervisor
									? {
											backgroundColor: theme.palette.action.hover,
									  }
									: {},
							}}
						>
							<StyledTableCell align='left'>
								{indirect.firstName} {indirect.lastName}
								{indirect.attendanceToday === 'Present' && (
									<VerifiedIcon
										sx={{
											transform: 'translate(25%, 25%)',
											color: 'green',
										}}
									/>
								)}
								{indirect.attendanceToday === 'Absent' && (
									<CancelIcon
										sx={{
											transform: 'translate(25%, 25%)',
											color: 'primary.main',
										}}
									/>
								)}
								{indirect.attendanceToday === 'Days Off' && (
									<CancelIcon
										sx={{
											transform: 'translate(25%, 25%)',
											color: 'warning.main',
										}}
									/>
								)}
							</StyledTableCell>
							<StyledTableCell align='center'>
								<TimeSheetDialog
									employee={indirect}
									postConfirmLoadData={postConfirmLoadData}
									shiftDate={shiftDate}
								/>
							</StyledTableCell>
							<StyledTableCell align='center'>{indirect.employeeId}</StyledTableCell>
							<StyledTableCell align='center'>{indirect.primaryCraft}</StyledTableCell>
							<StyledTableCell align='center'>{indirect.classification}</StyledTableCell>
							<StyledTableCell align='center'>
								<Chip label={'Online'} variant={'Online'} />
							</StyledTableCell>
							{!isSupervisor && (
								<StyledTableCell align='center'>
									<Chip
										label={`${submitted}/${total} Submitted`}
										variant={allSubmitted ? 'success' : 'failure'}
									></Chip>
								</StyledTableCell>
							)}
						</TableRow>
						)
					})}
				</TableBody>
			</Table>
		</TableContainer>
	)
}
